module.exports = __webpack_public_path__ + "img/plane_track_mobile_4.3871a346.svg";